import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from 'shared/FormattedCurrency';
import Button from 'shared/Button';
import styled from 'styled-components';
import { printToSidekick } from 'checkout/helpers/helpers';

class RecentOrder extends Component {
    render() {
        //If not configured to print receipts or tickets, do not show reprint button.
        //If configured only to print receipts, change button text from "Reprint Tickets" to "Reprint Receipt"
        let hideReprintButton = false;
        let reprintButtonText = "Reprint Tickets";
        if (this.props.kioskOptions.printReceipts !== undefined && this.props.kioskOptions.printReceiptsAndTickets !== undefined) {
            if (!this.props.kioskOptions.printReceipts && !this.props.kioskOptions.printReceiptsAndTickets) {
                hideReprintButton = true;
            } else {
                if (this.props.kioskOptions.printReceipts) {
                    reprintButtonText = "Reprint Receipt";
                }
            }
        }

        return(
            <RecentOrdersInfo className="recent-order__info">
                <p>Completed: {this.props.reserved}</p>
                <p>Confirmation ID: {this.props.confirmation}</p>
                {this.renderTickets()}
                {!hideReprintButton && <Button className="button button--block button--full" onClick={this.reprintTickets}>{reprintButtonText}</Button>}
            </RecentOrdersInfo>
        )
    }

    renderTickets = () => {
        return Object.values(this.props.tickets).map((ticket, i) => {
            return <div key={i}>
                <p>{ticket.quantity} x {ticket.title} - <FormattedCurrency>{ticket.amount}</FormattedCurrency></p>
            </div>
        });
    }

    reprintTickets = () => {
        printToSidekick(this.props.apiUrl, this.props.id, this.props.sidekick);
    }
}

RecentOrder.propTypes = {
    reserved: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    tickets: PropTypes.object.isRequired,
    sidekick: PropTypes.any,
    apiUrl: PropTypes.string.isRequired,
}

RecentOrder.defaultProps = {
}

export default RecentOrder;


const RecentOrdersInfo = styled.div`
    // margin-bottom: 30px;
    display: block;
    position: relative;
    :after {
    content: "";
    display: table;
    clear: both;
    }
    div{
        margin-bottom: 12px;
    }
`
